var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.ruleForm, "label-width": "75px" },
    },
    [
      _c(
        "div",
        { staticClass: "scroll-list" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("yhzh"), prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "width100",
                          model: {
                            value: _vm.userStatus.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.userStatus, "status", $$v)
                            },
                            expression: "userStatus.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("zhengchang"), value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: _vm.$t("jinyong"), value: 0 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 16, offset: 1 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("jzsc"), prop: "status" } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex-start align-center" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "120px" },
                            attrs: { size: "small", min: 0, max: 30 },
                            model: {
                              value: _vm.userStatus.day,
                              callback: function ($$v) {
                                _vm.$set(_vm.userStatus, "day", $$v)
                              },
                              expression: "userStatus.day",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("天")]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: { size: "small", min: 0, max: 23 },
                            model: {
                              value: _vm.userStatus.hour,
                              callback: function ($$v) {
                                _vm.$set(_vm.userStatus, "hour", $$v)
                              },
                              expression: "userStatus.hour",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("时")]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: { size: "small", min: 0, max: 59 },
                            model: {
                              value: _vm.userStatus.minutes,
                              callback: function ($$v) {
                                _vm.$set(_vm.userStatus, "minutes", $$v)
                              },
                              expression: "userStatus.minutes",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("分")]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("djly"), prop: "remark" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("qsryy"),
                          type: "textarea",
                          row: 3,
                        },
                        model: {
                          value: _vm.userStatus.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.userStatus, "remark", $$v)
                          },
                          expression: "userStatus.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("jyzt"), prop: "deal_status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "width100",
                          model: {
                            value: _vm.moneyStatus.deal_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.moneyStatus, "deal_status", $$v)
                            },
                            expression: "moneyStatus.deal_status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("zhengchang"), value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: _vm.$t("jinyong"), value: 0 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 16, offset: 1 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("jzsc"), prop: "deal_status" } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex-start align-center" },
                        [
                          _c("el-input-number", {
                            attrs: { size: "small", min: 0, max: 30 },
                            model: {
                              value: _vm.moneyStatus.day,
                              callback: function ($$v) {
                                _vm.$set(_vm.moneyStatus, "day", $$v)
                              },
                              expression: "moneyStatus.day",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("天")]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: { size: "small", min: 0, max: 23 },
                            model: {
                              value: _vm.moneyStatus.hour,
                              callback: function ($$v) {
                                _vm.$set(_vm.moneyStatus, "hour", $$v)
                              },
                              expression: "moneyStatus.hour",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("时")]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: { size: "small", min: 0, max: 59 },
                            model: {
                              value: _vm.moneyStatus.minutes,
                              callback: function ($$v) {
                                _vm.$set(_vm.moneyStatus, "minutes", $$v)
                              },
                              expression: "moneyStatus.minutes",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("分")]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("djly"), prop: "remark" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("qsryy"),
                          type: "textarea",
                          row: 3,
                        },
                        model: {
                          value: _vm.moneyStatus.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.moneyStatus, "remark", $$v)
                          },
                          expression: "moneyStatus.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("txzt"), prop: "withdraw_status" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "width100",
                          model: {
                            value: _vm.withdrawStatus.withdraw_status,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.withdrawStatus,
                                "withdraw_status",
                                $$v
                              )
                            },
                            expression: "withdrawStatus.withdraw_status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("zhengchang"), value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: _vm.$t("jinyong"), value: 0 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 16, offset: 1 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("jzsc"), prop: "deal_status" } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex-start align-center" },
                        [
                          _c("el-input-number", {
                            attrs: { size: "small", min: 0, max: 30 },
                            model: {
                              value: _vm.withdrawStatus.day,
                              callback: function ($$v) {
                                _vm.$set(_vm.withdrawStatus, "day", $$v)
                              },
                              expression: "withdrawStatus.day",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("天")]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: { size: "small", min: 0, max: 23 },
                            model: {
                              value: _vm.withdrawStatus.hour,
                              callback: function ($$v) {
                                _vm.$set(_vm.withdrawStatus, "hour", $$v)
                              },
                              expression: "withdrawStatus.hour",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("时")]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: { size: "small", min: 0, max: 59 },
                            model: {
                              value: _vm.withdrawStatus.minutes,
                              callback: function ($$v) {
                                _vm.$set(_vm.withdrawStatus, "minutes", $$v)
                              },
                              expression: "withdrawStatus.minutes",
                            },
                          }),
                          _c("span", { staticClass: "range" }, [_vm._v("分")]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("djly"), prop: "remark" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("qsryy"),
                          type: "textarea",
                          row: 3,
                        },
                        model: {
                          value: _vm.withdrawStatus.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.withdrawStatus, "remark", $$v)
                          },
                          expression: "withdrawStatus.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin_top_20 flex-end" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("ruleForm")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("ruleForm")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calcelText")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }